import React from 'react';

const NavbarToggler = () => {
  return (
    <button 
      className="navbar-toggler" 
      type="button" 
      data-bs-toggle="collapse" 
      data-bs-target="#sidebar-menu"
      aria-controls="sidebar-menu" 
      aria-expanded="false" 
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon"></span>
    </button>
  );
};

export default NavbarToggler; 